import React from 'react';
import { FormattedMessage } from 'react-intl';

import styles from './FlowCorrelation.module.scss';

interface Props {
  flowCorrelation?: number;
}

const FlowCorrelation: React.FC<Props> = ({ flowCorrelation }) => {
  const getFlowCorrelationCheck = () => {
    if (flowCorrelation === null || flowCorrelation === undefined) {
      return (
        <div className={styles.flowCorrelationRed}>
          <FormattedMessage id="dataManagement.dataQuality.dataConsistency.flowCorrelationFailure" />
        </div>
      );
    }

    return (
      <div
        className={flowCorrelation >= 0.8 ? styles.flowCorrelationGreen : styles.flowCorrelationRed}
      >
        {Math.round(flowCorrelation * 100)}%
      </div>
    );
  };

  return (
    <div>
      <div className={styles.title}>
        <FormattedMessage id="dataManagement.dataQuality.dataConsistency.flowCorrelation" />
      </div>
      {getFlowCorrelationCheck()}
    </div>
  );
};

export default FlowCorrelation;
